import nodemailer from 'nodemailer';

export function getTransporter() {
  return nodemailer.createTransport({
    host: process.env.SMTP_HOST || 'smtp.gmail.com',
    port: parseInt(process.env.SMTP_PORT || '587', 10),
    secure: parseInt(process.env.SMTP_PORT || '587', 10) === 465,
    auth: {
      user: process.env.SMTP_USER,
      pass: process.env.SMTP_PASS,
    },
  });
}

export function buildEmailHTML(params: {
  customerName: string;
  companyName: string;
  email: string;
  phone: string;
  country: string;
  productName: string;
  description: string;
  material: string;
  finish: string;
  color: string;
  height: string;
  width: string;
  depth: string;
  weight: string;
  referenceImage: string | null;
  selectedImage: string | null;
  submissionDate: string;
  userIP: string;
  browser: string;
  os: string;
}): string {
  const {
    customerName,
    companyName,
    email,
    phone,
    country,
    productName,
    description,
    material,
    finish,
    color,
    height,
    width,
    depth,
    weight,
    referenceImage,
    selectedImage,
    submissionDate,
    userIP,
    browser,
    os,
  } = params;

  const referenceImageHtml = referenceImage
    ? `<tr>
        <td style="padding: 32px 40px;">
          <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">📎 REFERENCE IMAGE</h2>
          <div style="text-align: center; background: #f8f8f8; border-radius: 12px; padding: 20px;">
            <img src="${referenceImage}" alt="Reference Image" style="max-width: 100%; max-height: 400px; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" />
          </div>
        </td>
      </tr>`
    : '';

  const selectedImageHtml = selectedImage
    ? `<tr>
        <td style="padding: 0 40px 32px;">
          <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">🤖 AI GENERATED PREVIEW</h2>
          <div style="text-align: center; background: #f8f8f8; border-radius: 12px; padding: 20px;">
            <img src="${selectedImage}" alt="AI Generated Preview" style="max-width: 100%; max-height: 500px; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" />
          </div>
        </td>
      </tr>`
    : '';

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>New AI Product Inquiry</title>
</head>
<body style="margin: 0; padding: 0; font-family: 'Segoe UI', Arial, sans-serif; background-color: #f0f0f0;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f0f0f0; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="640" cellpadding="0" cellspacing="0" style="max-width: 640px; width: 100%; background: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.12);">
          
          <!-- Header -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); padding: 40px; text-align: center;">
              <div style="display: inline-block; background: rgba(201,168,76,0.15); border: 1px solid rgba(201,168,76,0.4); border-radius: 12px; padding: 12px 24px; margin-bottom: 20px;">
                <span style="color: #c9a84c; font-size: 13px; font-weight: 700; letter-spacing: 2px;">✦ EXPORT EXCELLENCE</span>
              </div>
              <h1 style="margin: 0 0 8px; color: #ffffff; font-size: 28px; font-weight: 800; letter-spacing: 1px;">AI Product Inquiry</h1>
              <p style="margin: 0; color: rgba(255,255,255,0.6); font-size: 15px;">New submission from AI Product Builder</p>
              <div style="margin-top: 24px; height: 2px; background: linear-gradient(to right, transparent, #c9a84c, transparent);"></div>
            </td>
          </tr>

          <!-- Customer Information -->
          <tr>
            <td style="padding: 32px 40px 0;">
              <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">👤 CUSTOMER INFORMATION</h2>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="50%" style="padding: 8px 12px 8px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">FULL NAME</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 600;">${customerName}</div>
                    </div>
                  </td>
                  <td width="50%" style="padding: 8px 0 8px 12px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">COMPANY</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 600;">${companyName || '—'}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="50%" style="padding: 8px 12px 8px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">EMAIL</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 600;">${email}</div>
                    </div>
                  </td>
                  <td width="50%" style="padding: 8px 0 8px 12px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">PHONE</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 600;">${phone || '—'}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 8px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">COUNTRY</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 600;">${country || '—'}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Product Information -->
          <tr>
            <td style="padding: 24px 40px 0;">
              <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">📦 PRODUCT INFORMATION</h2>
              <div style="background: #f8f9ff; border-radius: 10px; padding: 16px; border-left: 3px solid #c9a84c; margin-bottom: 12px;">
                <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 6px;">PRODUCT NAME</div>
                <div style="color: #1a1a2e; font-size: 18px; font-weight: 700;">${productName}</div>
              </div>
              <div style="background: #f8f9ff; border-radius: 10px; padding: 16px; border-left: 3px solid #c9a84c; margin-bottom: 12px;">
                <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 6px;">DESCRIPTION</div>
                <div style="color: #1a1a2e; font-size: 14px; line-height: 1.7;">${description}</div>
              </div>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="33%" style="padding: 4px 8px 4px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">MATERIAL</div>
                      <div style="color: #1a1a2e; font-size: 14px; font-weight: 700;">${material || '—'}</div>
                    </div>
                  </td>
                  <td width="33%" style="padding: 4px 4px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">FINISH</div>
                      <div style="color: #1a1a2e; font-size: 14px; font-weight: 700;">${finish || '—'}</div>
                    </div>
                  </td>
                  <td width="33%" style="padding: 4px 0 4px 8px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">COLOR</div>
                      <div style="color: #1a1a2e; font-size: 14px; font-weight: 700;">${color || '—'}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Dimensions -->
          <tr>
            <td style="padding: 24px 40px 0;">
              <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">📐 DIMENSIONS</h2>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="25%" style="padding: 4px 6px 4px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">HEIGHT</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 700;">${height ? height + ' cm' : '—'}</div>
                    </div>
                  </td>
                  <td width="25%" style="padding: 4px 6px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">WIDTH</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 700;">${width ? width + ' cm' : '—'}</div>
                    </div>
                  </td>
                  <td width="25%" style="padding: 4px 6px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">DEPTH</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 700;">${depth ? depth + ' cm' : '—'}</div>
                    </div>
                  </td>
                  <td width="25%" style="padding: 4px 0 4px 6px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c; text-align: center;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">WEIGHT</div>
                      <div style="color: #1a1a2e; font-size: 15px; font-weight: 700;">${weight ? weight + ' kg' : '—'}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Reference Image -->
          ${referenceImageHtml}

          <!-- AI Generated Preview -->
          ${selectedImageHtml}

          <!-- Submission Details -->
          <tr>
            <td style="padding: ${referenceImage || selectedImage ? '0' : '24px'} 40px 32px;">
              <h2 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; border-bottom: 2px solid #c9a84c; padding-bottom: 12px;">🔍 SUBMISSION DETAILS</h2>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="50%" style="padding: 6px 8px 6px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">SUBMISSION DATE</div>
                      <div style="color: #1a1a2e; font-size: 13px; font-weight: 600;">${submissionDate}</div>
                    </div>
                  </td>
                  <td width="50%" style="padding: 6px 0 6px 8px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">IP ADDRESS</div>
                      <div style="color: #1a1a2e; font-size: 13px; font-weight: 600;">${userIP}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="50%" style="padding: 6px 8px 6px 0;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">BROWSER</div>
                      <div style="color: #1a1a2e; font-size: 13px; font-weight: 600;">${browser}</div>
                    </div>
                  </td>
                  <td width="50%" style="padding: 6px 0 6px 8px;">
                    <div style="background: #f8f9ff; border-radius: 10px; padding: 14px 16px; border-left: 3px solid #c9a84c;">
                      <div style="color: #888; font-size: 11px; font-weight: 600; letter-spacing: 1px; margin-bottom: 4px;">OPERATING SYSTEM</div>
                      <div style="color: #1a1a2e; font-size: 13px; font-weight: 600;">${os}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); padding: 28px 40px; text-align: center;">
              <div style="height: 1px; background: linear-gradient(to right, transparent, #c9a84c, transparent); margin-bottom: 20px;"></div>
              <p style="margin: 0 0 8px; color: rgba(255,255,255,0.5); font-size: 13px;">This enquiry was submitted from the</p>
              <p style="margin: 0 0 16px; color: #c9a84c; font-size: 14px; font-weight: 700; letter-spacing: 1px;">✦ AI PRODUCT BUILDER ✦</p>
              <p style="margin: 0; color: rgba(255,255,255,0.3); font-size: 11px;">© ${new Date().getFullYear()} Export Excellence. All rights reserved.</p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
}
